<div class="dialog-container" #dialogContainer>
    <h4 mat-dialog-title class="dialog-title">{{data.timeType}}</h4>
    <div mat-dialog-content class="dialog-content">
        <small *ngIf="locationAlert != null" class="text-danger text-center">{{locationAlert}}</small>
        <div *ngIf="!permissionGranted" id="loading">
            <p>{{textLoading}}</p>
        </div>
        <div *ngIf="!isLocationReady && !locationAlert">
            Loading location...
        </div>
        <webcam *ngIf="showCamera && permissionGranted" [height]="yourDesiredHeight" [width]="yourDesiredWidth"
            [videoOptions]="videoOptions" [allowCameraSwitch]="allowCameraSwitch" [trigger]="triggerObservable"
            (imageCapture)="handleImageCapture($event)"></webcam>
        <form [formGroup]="NoteGroup" class="w-100 mt-2">
            <mat-form-field *ngIf="accountInfo.isAllowClient" class="example-full-width col-12" appearance="outline">
                <mat-label>Select client</mat-label>
                <mat-select formControlName="client">
                    <mat-option *ngFor="let client of clients" [value]="client.C_BPartner_ID">
                        {{ client.clientName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="example-full-width col-12" appearance="outline">
                <mat-label>Branch *</mat-label>
                <mat-select formControlName="branch" required>
                    <mat-option *ngFor="let b of branches" [value]="b.C_Activity_ID">
                        {{ b.branchName }}
                    </mat-option>
                </mat-select>
                <mat-error>Branch is required</mat-error>
            </mat-form-field>
            <mat-form-field *ngIf="!accountInfo.isAllowClient" class="example-full-width col-12" appearance="outline">
                <mat-label>Note:</mat-label>
                <input matInput formControlName="note">
            </mat-form-field>
            <mat-form-field *ngIf="accountInfo.isAllowClient" class="example-full-width col-12" appearance="outline">
                <mat-label>Card/Ticket:</mat-label>
                <input matInput formControlName="card">
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-4">
        <button mat-button class="cancel-button" (click)="onNoClick()">Cancel</button>
        <button mat-button class="yes-button" (click)="captureImage()"
            [disabled]="!isLocationReady || isDisabled || !permissionGranted || isProcessing || NoteGroup.get('branch').invalid" cdkFocusInitial>
            <span *ngIf="!isProcessing">{{data.timeType}}</span>
            <span *ngIf="isProcessing">Processing...</span>
        </button>
    </div>
</div>